// extracted by mini-css-extract-plugin
export var link = "share-module--link--+3Y71";
export var svg = "share-module--svg--cmAWi";
export var wrapper = "share-module--wrapper--tviWP";